// js
import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../../common/ProgressBar';


const RollUpOverviewChartPPTX = ({ percent }) => {
  return (
    <ProgressBar
      height={10}
      stripeSize={3}
      stripeColor={'white'}
      percent={percent}
    />
  );
};

RollUpOverviewChartPPTX.propTypes = {
  percent: PropTypes.number.isRequired
};

export default RollUpOverviewChartPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RollUpOverviewChartPPTX.js